export const SigmaPermissions = {
  default: 'User.RiskMonitoring.Sigma',
  consolidatedView: 'User.RiskMonitoring.Sigma.ConsolidatedView',
} as const;
